const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * Today's date as YYYY-MM-DD in the writer's own time zone.
 * @param {Date} [now]
 */
export function todayISO(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** @param {string} value */
export function isISODate(value: unknown) {
  const m = typeof value === "string" ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null;
  if (!m) return false;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(Date.UTC(y, mo - 1, d));
  return date.getUTCFullYear() === y && date.getUTCMonth() === mo - 1 && date.getUTCDate() === d;
}

/**
 * The site's date style: "08 Oct 2026". Anything that is not a plain ISO
 * date is returned as written.
 * @param {string} value
 */
export function formatDisplayDate(value: string) {
  const text = String(value ?? "").trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/.exec(text);
  if (!m) return text;
  const month = MONTHS[Number(m[2]) - 1];
  if (!month) return text;
  return `${m[3]} ${month} ${m[1]}`;
}

/**
 * Counts words with the browser's own word segmentation, so it works for
 * French and other scripts without a rule list.
 * @param {string} text
 */
export function countWords(text: string) {
  if (!text.trim()) return 0;
  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter(undefined, { granularity: "word" });
    let count = 0;
    for (const part of segmenter.segment(text)) {
      if (part.isWordLike) count += 1;
    }
    return count;
  }
  return (text.match(/[\p{L}\p{N}][\p{L}\p{N}'’-]*/gu) || []).length;
}

/**
 * Counts characters as a reader sees them (an accented letter or an emoji is one),
 * spaces included.
 * @param {string} text
 */
export function countChars(text: string) {
  if (!text) return 0;
  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    let count = 0;
    for (const _ of new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(text)) {
      count += 1;
    }
    return count;
  }
  return [...text].length;
}
